var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"nav-item",attrs:{"active-class":`active ${_vm.item.activeClass}`,"color":"primary","target":"_","to":_vm.to,"href":_vm.href}},[_c('inline-svg',{attrs:{"src":_vm.item.icon}}),(_vm.item.title)?_c('v-list-item-title',{staticClass:"nav-item-title"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }